// Generato da gymmi-docs/scripts/versioning.py.
export const CONTRACT_VERSION = '1.0.0-draft.90'
